<div cdk-overlay-origin #trigger class="combobox-container" [class.combobox-with-button]="buttonLabel()">
  @if (type() === 'number') {
    <input
      #inputEl
      class="combobox-input"
      type="text"
      inputNumber
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [attr.min]="min()"
      [value]="displayValue"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)" />
  } @else {
    <input
      #inputEl
      class="combobox-input"
      type="text"
      [placeholder]="placeholder()"
      [disabled]="isDisabled()"
      [value]="displayValue"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)" />
  }
  @if (suffix() || suffixHint()) {
    <span class="combobox-suffix-group">
      @if (suffix()) {
        <span class="combobox-suffix">{{ suffix() }}</span>
      }
      @if (suffixHint()) {
        <span class="combobox-suffix-hint">{{ suffixHint() }}</span>
      }
    </span>
  }
  @if (buttonLabel()) {
    <button
      type="button"
      class="combobox-button"
      [disabled]="isDisabled()"
      tabindex="-1"
      (mousedown)="$event.preventDefault()"
      (click)="toggleDropdown()">
      {{ buttonLabel() }}
    </button>
  } @else {
    <button
      type="button"
      class="combobox-chevron"
      [disabled]="isDisabled()"
      tabindex="-1"
      (mousedown)="$event.preventDefault()"
      (click)="toggleDropdown()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
      </svg>
    </button>
  }
  <ng-template
    cdk-connected-overlay
    cdkConnectedOverlayLockPosition
    cdkConnectedOverlayHasBackdrop
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayDisableClose]="true"
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayMinWidth]="originWidth"
    (detach)="closeDropdown()"
    (backdropClick)="closeDropdown()"
    (overlayOutsideClick)="closeDropdown()">
    <div class="combobox-dropdown" role="listbox">
      @for (option of suggestions(); track option.value; let i = $index) {
        <div
          class="combobox-option"
          role="option"
          [class.highlighted]="i === highlightedIndex"
          (click)="selectOption(option)"
          (mouseenter)="highlightedIndex = i">
          {{ option.label }}
        </div>
      }
    </div>
  </ng-template>
</div>
